// extracted by mini-css-extract-plugin
export default {"projectsGrid":"projectsGrid_projectsGrid__fftFo"};